import { createFileRoute, redirect } from '@tanstack/react-router'

/** Dirección anterior de Actividad API: se conserva para no romper enlaces guardados (con sus filtros). */
export const Route = createFileRoute('/_app/integration')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/api-activity', search: search as never, replace: true })
  },
})
